import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Field from 'redux-form/es/Field';
import InputSelectField from 'components/Credit24/Core/Controls/InputSelectField';
import UpgradeProductItem from 'components/Credit24/LoanApplication/OfferDetailsAU/UpgradeProductItem';

const propTypes = {
  product: PropTypes.object.isRequired,
  creditLimits: PropTypes.array,
  paymentInterval: PropTypes.string,
  efectiveTerm: PropTypes.string,
  productType: PropTypes.string,
};

const UpgradeProduct = ({
  product, creditLimits, paymentInterval, efectiveTerm, productType,
}) => {
  const upgradeProductItems = [
    {
      id: 'apr',
      value: product.apr,
      style: 'percent',
    },
    {
      id: 'annualInterest',
      value: product.annualInterest,
      style: 'percent',
    },
    {
      id: 'upgradeFee',
      value: product.upgradeFee,
    },
    {
      id: `serviceFee.${paymentInterval}`,
      value: product.serviceFee,
    },
    {
      id: 'withdrawalFee',
      value: product.withdrawFee,
    },
  ];

  return (
    <div className="loan-form__step">
      <h1 className="loan-form__step-title">
        <FormattedMessage id="offer.upgrade.title" />
      </h1>
      <div className="loan-form__step-body">
        <div className="content-block">
          <div className="content-columns">
            <div className="content-columns__item">
              <div className="upgrade-product upgrade-product--left">
                <div className="upgrade-product__item">
                  <div className="upgrade-product__item-value">
                    <Field
                      emptyTextKey="offer.upgrade.creditLimit"
                      name="creditLimit"
                      component={InputSelectField}
                      options={creditLimits}
                      isFullWidth
                    />
                  </div>
                </div>
                <UpgradeProductItem
                  id={`newMmp.${paymentInterval}`}
                  value={product.mmp}
                />
                {
                  productType === 'CREDIT_LINE'
                    && (
                    <div className="upgrade-product__payment-info">
                      <FormattedMessage
                        id="offer.upgrade.paymentInfo"
                        values={{ efectiveTerm }}
                      />
                    </div>
                    )
                }

              </div>
            </div>
            <div className="content-columns__item">
              <div className="upgrade-product">
                {upgradeProductItems.map(({ id, ...rest }) => (
                  <UpgradeProductItem key={id} id={id} {...rest} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

UpgradeProduct.propTypes = propTypes;

export default UpgradeProduct;
